import * as React from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { useCurrencies, updateCurrency } from "services/currencyService";
import EditCurrency from "./Editcurrency.jsx";
import { ActiveCell, EditCommandCell, SignatureCell } from "../GridComponents";
import { toast } from "react-toastify";
import { GridLoader } from "components/GridLoader.jsx";

const Currencylist = () => {
  const { data: currencyList = [], loading } = useCurrencies();

  const [openForm, setOpenForm] = React.useState(false);
  const [editItem, setEditItem] = React.useState(null);

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    try {
      const data = {
        currencyCode: event.currencyCode,
        name: event.name,
        symbol: event.symbol,
        active: event.active,
      };
      const result = await updateCurrency(event.currencyCode, data);
      if (result.success) {
        toast.success(`Currency '${data.name}' has been updated`);
        setOpenForm(false);
      } else {
        toast.error("Error occurred while updating currency");
      }
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );
  return (
    <div className="settings-grid h-100">
      <Grid data={currencyList} style={{ height: "100%" }} showLoader={loading} loader={
        <div style={{ height: "50px" }}>
          <GridLoader />
        </div>
      }>
        <GridNoRecords>
          {loading ? (
            <span></span>
          ) : (
            currencyList && currencyList?.length === 0 && "No records available"
          )}
        </GridNoRecords>
        <Column field="symbol" title=" " cell={SignatureCell} width="80" />
        <Column field="currencyCode" title="Code" width="100" />
        <Column field="name" title="Name" />
        <Column cell={ActiveCell} title="Active" field="active" width="75" />
        <Column title=" " cell={MyEditCommandCell} width="60" />
      </Grid>
      {openForm && (
        <EditCurrency
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
        />
      )}
    </div>
  );
};

export default Currencylist;
